module.exports = {"pathContext":{"name":"MedicationsFilledReportResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"medications","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"MedicationsFilledReportItem","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"totalCount","type":{"kind":"SCALAR","name":"Int","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-medications-filled-report-result.json
// module id = 1863
// module chunks = 81391573198118